import {
  GET_LETTER_ORDERS_LIST_REQUEST,
  GET_LETTER_ORDERS_LIST_SUCCESS,
  GET_LETTER_ORDERS_LIST_FAILURE,
  POST_LETTER_ORDERS_SALESFORCE_SYNC_REQUEST,
  POST_LETTER_ORDERS_SALESFORCE_SYNC_SUCCESS,
  POST_LETTER_ORDERS_SALESFORCE_SYNC_FAILURE,
  GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_REQUEST,
  GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_SUCCESS,
  GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_FAILURE,
  GET_DELAY_LETTER_ORDERS_REQUEST,
  GET_DELAY_LETTER_ORDERS_SUCCESS,
  GET_DELAY_LETTER_ORDERS_FAILURE,
  LOG_OUT_SUCCESS,
  INITIALIZE_MESSAGE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils'

const initialState = {
  pageInfo: {},
  letterOrderList: [],
  isLoading: false,
  message: '',
  errorMessage: '',
  isPostingSalesforceSync: false,
  selectedYearMonthOverview: {},
  isLoadingSelectedYearMonthOverview: false,
  isCheckOK: true,
  checkMessage: '',
  delayLetterOrderList: [],
  isLoadingDelayLetterOrderList: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LETTER_ORDERS_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        message: '',
        errorMessage: '',
        pageInfo: {},
        letterOrderList: [],
      }
    case GET_LETTER_ORDERS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: '',
        letterOrderList: action.payload.data,
        pageInfo: action.payload.pageInfo,
      }
    case GET_LETTER_ORDERS_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        message: '',
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case GET_DELAY_LETTER_ORDERS_REQUEST:
      return {
        ...state,
        isLoadingDelayLetterOrderList: true,
        message: '',
        errorMessage: '',
        pageInfo: {},
        delayLetterOrderList: [],
      }
    case GET_DELAY_LETTER_ORDERS_SUCCESS:
      return {
        ...state,
        isLoadingDelayLetterOrderList: false,
        message: '',
        errorMessage: '',
        delayLetterOrderList: action.payload.data,
        pageInfo: action.payload.pageInfo,
      }
    case GET_DELAY_LETTER_ORDERS_FAILURE:
      return {
        ...state,
        isLoadingDelayLetterOrderList: false,
        message: '',
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case POST_LETTER_ORDERS_SALESFORCE_SYNC_REQUEST:
      return {
        ...state,
        isPostingSalesforceSync: true,
      }
    case POST_LETTER_ORDERS_SALESFORCE_SYNC_SUCCESS:
      return {
        ...state,
        isPostingSalesforceSync: false,
        message: 'Salesforceに同期中。完了まで数分かかるので、後ほどご確認ください。'
      }
    case POST_LETTER_ORDERS_SALESFORCE_SYNC_FAILURE:
      return {
        ...state,
        isPostingSalesforceSync: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_POST_SALESFORCE_SYNC_FAILURE),
      }
    case GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_REQUEST:
      return {
        ...state,
        isCheckOK: initialState.isCheckOK,
        checkMessage: initialState.checkMessage,
      }
    case GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_SUCCESS:
      return {
        ...state,
        isCheckOK: action.payload.isCheckOK,
        checkMessage: action.payload.checkMessage,
      }
    case GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_FAILURE:
      return {
        ...state,
        isCheckOK: initialState.isCheckOK,
        checkMessage: initialState.checkMessage,
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    case INITIALIZE_MESSAGE:
      return {
        ...state,
        message: initialState.message,
        errorMessage: initialState.errorMessage,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/letterOrderList.js